import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 4C7.58886 4 4 7.58886 4 12C4 16.4111 7.58886 20 12 20C13.4067 20 14.79 19.6299 16.001 18.9292L15 17.1977C14.0928 17.7226 13.0552 18 12 18C8.69142 18 5.99999 15.3086 5.99999 12C5.99999 8.69142 8.69142 5.99999 12 5.99999C15.3086 5.99999 18 8.69142 18 12V12.8711C18 13.5254 17.5796 14 17 14C16.4487 14 16 13.5513 16 13V9H14.6176C13.9141 8.38542 13.0053 7.99998 12 7.99998C9.79443 7.99998 7.99998 9.79443 7.99998 12C7.99998 14.2056 9.79443 16 12 16C13.0503 16 13.9999 15.5847 14.7144 14.9202C15.2651 15.5747 16.0797 16 17 16C18.6821 16 20 14.6255 20 12.8711V12C20 7.58886 16.4111 4 12 4ZM12 14C10.897 14 10 13.103 10 12C10 10.897 10.897 10 12 10C13.103 10 14 10.897 14 12C14 13.103 13.103 14 12 14Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Mention"
);
